(function ($) {
  let players;
  let player;
  let current;
  let currentFormatted;
  let animFrame;

  $(document).ready(() => {
    players = document.querySelectorAll("div.oog-player-audio audio");
    if (!players) {
      return;
    }
    let numPlayers = players.length;

    while (--numPlayers >= 0) {
      player = players.item(numPlayers);

      player.addEventListener("durationchange", (evt) => {
        const container = getContainer(evt.currentTarget);
        container.attr("duration", evt.currentTarget.duration);
        $(".oog-player-audio-timer", container).text(
          formatTime(evt.currentTarget.duration),
        );
      });

      player.addEventListener("progress", (evt) => {
        const container = getContainer(evt.currentTarget);
        if (evt.currentTarget.buffered.length === 0) {
          return;
        }
        $(container).attr("load-progress", evt.currentTarget.buffered.end(0));
      });

      player.addEventListener("timeupdate", (evt) => {
        const container = getContainer(evt.currentTarget);
        current = evt.currentTarget.currentTime;

        if (currentFormatted !== formatTime(current)) {
          currentFormatted = formatTime(current);
          $(".oog-player-audio-timer", container).text(currentFormatted);
        }
      });
      player.addEventListener("ended", () => {
        cancelAnimationFrame(animFrame);
      });

      player.addEventListener("play", (evt) => {
        const container = getContainer(evt.currentTarget);
        if (!container.attr("duration")) {
          container.attr("duration", evt.currentTarget.duration);
        }
        animFrame = requestAnimationFrame(updateSeekBar);
      });

      // Get title if not set
      const container = getContainer(player)[0];
      if (
        container.querySelector(".oog-player-audio-title").textContent === ""
      ) {
        getTitle(player.src, container);
      }
    }

    $("a.play-pause-button").on("click", (evt) => {
      evt.preventDefault();
      const container = getContainer(evt.currentTarget),
        player = $("audio", container)[0];

      $("div.oog-player-audio").removeClass("pause active");
      if (player.paused) {
        pauseAllPlayersExcept(player);
        $(container).addClass("pause active");
        player.play();
      } else {
        player.pause();
      }
    });

    $(".oog-player-audio").on("click", ".oog-player-audio-duration", seek);
  });

  function seek(evt) {
    const container = getContainer(evt.currentTarget),
      pos = evt.offsetX / evt.currentTarget.clientWidth;

    if (pos < 0 || pos > 1) {
      return;
    }

    player = $("audio", container)[0];
    player.currentTime = parseFloat($(container).attr("duration")) * pos;
  }

  function updateSeekBar() {
    const container = $("div.oog-player-audio.active"),
      duration = parseFloat(container.attr("duration")),
      loadProgress = parseFloat(container.attr("load-progress"));

    $(".buffered", container).width((loadProgress / duration) * 100 + "%");
    $(".progress", container).width((current / duration) * 100 + "%");

    animFrame = requestAnimationFrame(updateSeekBar);
  }

  function getContainer(item) {
    return $(item).closest("div.oog-player-audio");
  }

  function getTitle(url, container) {
    const data = {
      action: "oog_media_player_get_audio_title",
      file: url,
    };
    $.post("/wp-admin/admin-ajax.php", data).done((title) => {
      $(".oog-player-audio-title", container).text(
        title + String.fromCharCode(160),
      );
    });
  }

  function formatTime(time) {
    time = Math.round(time);
    const minutes = "0" + Math.floor(time / 60);
    const seconds = "0" + (time - minutes * 60);
    return minutes.slice(-2) + ":" + seconds.slice(-2);
  }

  /**
   * Pauses all players on the page
   * @param player
   */
  function pauseAllPlayersExcept(player) {
    let np = players.length;

    while (--np >= 0) {
      if (players.item(np) !== player && !players.item(np).paused) {
        players.item(np).pause();
      }
    }
  }
})(jQuery);
